<template>
    <div>
        <div class="relative bg-white text-black pt-28 pb-24" :class="$device.isDesktop ? 'lg:pt-52' : 'lg:pt-40'">
            <div class="container">
                <div class="grid grid-cols-12 gap-5">
                    <div class="col-span-12 md:col-span-8 md:col-start-3">
                        <h1 class="title title-xl mb-12">
                            {{ model.title }}
                        </h1>

                        <p class="mb-12">{{ model.lead }}</p>

                        <img :src="model.cover_image" :alt="model.title" class="mb-12" />

                        <div class="tinymce-content" v-html="model.body"></div>

                        <SectionDownloadables v-if="model.downloads" :attachments="model.downloads" />

                        <div
                            class="flex flex-col-reverse sm:flex-row sm:justify-between sm:items-center pt-12 md:mt-16"
                        >
                            <NuxtLink
                                :to="localePath('/job-seeker/advice')"
                                class="p-component p-button p-button-secondary p-button-text mt-12 sm:mt-0"
                            >
                                <span class="pi pi-arrow-left p-button-icon p-button-icon-left"></span>
                                <span class="p-button-label">{{ $t('generic.back') }}</span>
                            </NuxtLink>

                            <div class="flex flex-col sm:flex-row sm:items-center">
                                <div class="sm:mr-3 mb-5 sm:mb-0">{{ $t('generic.share') }}</div>
                                <ArticleShareButtonGroup :title="model.title" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-10 sm:pt-16">
            <div class="container px-0">
                <SectionWrapper v-if="model.related" :title="$t('advice.more')" is-carousel-wrapper>
                    <div class="grid grid-cols-12 gap-5 mb-24">
                        <div
                            v-for="advice in model.related"
                            :key="`advice-${advice.id}`"
                            class="col-span-12 sm:col-span-6 lg:col-span-4"
                        >
                            <ArticleCard
                                :url="localePath(`/job-seeker/advice/${advice.slug}`)"
                                :title="advice.title"
                                :description="advice.lead"
                                :thumbnail="advice.cover_image"
                                class="h-full"
                                trimmed
                            />
                        </div>
                    </div>
                </SectionWrapper>

                <SectionWrapper
                    v-if="jobs && jobs.length"
                    title="Válogasson álláshirdetéseink között"
                    is-carousel-wrapper
                >
                    <JobsCarousel :jobs="jobs" />
                </SectionWrapper>
            </div>
        </div>
    </div>
</template>

<script>
import SectionWrapper from '../UI/SectionWrapper';
import ArticleShareButtonGroup from '@/components/UI/Buttons/ArticleShareButtonGroup';
import ArticleCard from '@/components/Cards/ArticleCard/ArticleCard';
import SectionDownloadables from '@/components/Sections/SectionDownloadables/SectionDownloadables';
import JobsCarousel from '@/components/Carousels/JobsCarousel';

export default {
    name: 'Advice',
    components: {
        SectionWrapper,
        ArticleShareButtonGroup,
        ArticleCard,
        JobsCarousel,
        SectionDownloadables,
    },
    props: {
        model: {
            type: Object,
            required: true,
        },
        jobs: {
            type: Array,
            required: true,
        },
    },
    mounted() {
        this.$store.commit('globals/setAlternateUrlsForCurrentPage', [{ key: 'fallback', path: '/job-seeker/advice' }]);
    },
    beforeDestroy() {
        this.$store.commit('globals/setAlternateUrlsForCurrentPage', null);
    },
};
</script>

<style scoped></style>
